import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { BrandThemeModel } from '@models/types'

interface BrandThemeProps {
  callbacks?: {
    onClick: () => void,
  },
  entity: BrandThemeModel,
  selected: boolean,
}

const BrandTheme = (props: BrandThemeProps) => {
  const {
    callbacks,
    entity: { id, title },
    selected,
  } = props

  const { onClick } = callbacks || {}

  return (
    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>
  )
}

export default BrandTheme
